import { Injectable, signal, computed } from '@angular/core';
import { TRANSLATIONS, Translations } from '../i18n/translations';

export type Lang = 'fr' | 'en' | 'it' | 'es' | 'nl' | 'de';

@Injectable({ providedIn: 'root' })
export class I18nService {
  private readonly LANG_KEY = 'ble_lang';
  private readonly LANG_MANUAL_KEY = 'ble_lang_manual';

  lang = signal<Lang>(this.restoreLang());

  t = computed<Translations>(() => TRANSLATIONS[this.lang()]);

  setLang(value: unknown): void {
    if (localStorage.getItem(this.LANG_MANUAL_KEY)) return;
    const v = Number(value);
    const lang: Lang = v === 1 ? 'fr' : v === 2 ? 'es' : v === 3 ? 'nl' : v === 4 ? 'de' : v === 5 ? 'it' : 'en';
    this.lang.set(lang);
    localStorage.setItem(this.LANG_KEY, lang);
  }

  switchLang(lang: Lang): void {
    this.lang.set(lang);
    localStorage.setItem(this.LANG_KEY, lang);
    localStorage.setItem(this.LANG_MANUAL_KEY, '1');
  }

  private restoreLang(): Lang {
    const stored = localStorage.getItem(this.LANG_KEY);
    if (stored === 'fr' || stored === 'en' || stored === 'it' || stored === 'es' || stored === 'nl' || stored === 'de') return stored;
    // Anglais par défaut (page de login) — pas de détection de la langue du
    // téléphone/navigateur. Après connexion, setLang() applique la langue du compte.
    return 'en';
  }
}
